import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SavingTipsRoutingModule } from './saving-tips-routing.module';
import { SavingTipsComponent } from './saving-tips.component';

@NgModule({
  declarations: [SavingTipsComponent],
  imports: [CommonModule, SavingTipsRoutingModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SavingTipsModule {}
